/**
 * @file store mutations
 * @author zhangzhimeng
 */
export default {
  // 导航树信息
  columnTreeList: [],
  // 用户信息
  user: null,
  tenant: null,
  websit: null,
  token: '',
  websitBanner: '',
  siteIntro: '',
  guidance: '',
  undertake: '',
  zipCode: '',
  contactMail: '',
  telephone: '',
  siteAddress: '',
  // 按钮权限参数
  buttonPermissionList: [],
  activeIndex: '',
  columnItem: [],
  columnItemParent: {},
  activeChildrenIndex: '',
  contentId: '',
  specialInfo: {},
  footerList: [],
  isLoggedIn: false,
  redirectPath: null,
  memberUnitId: null,
  isMemberUnit: false,
  memberUnit: {}
}



// WEBPACK FOOTER //
// ./src/store/state.js